import React, { useState } from "react";
import Modal from "./modal";
import { transformData } from "./transformData";
import { MdCached } from "react-icons/md";

const Loading = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 bg-gray-900 bg-opacity-50">
      <div className="flex items-center justify-center text-gray-600">
        <MdCached size={24} className="mr-1 animate-spin" />
        Loading...
      </div>
    </div>
  );
};

const Table = ({ data, deleteUri, isClickable = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [header, setIsHeader] = useState(null);
  const [additionalData, setIsAdditionalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  const openModal = async (data) => {
    const {id, submissionDate, hasDuplicate, applicationCount, ...rest} = data;
    setSelectedLeadId(id);
    setIsLoading(true);
    const response = await fetch('/form/details', {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({id}),
    });
    if (!response.ok) {
          throw new Error("Failed to fetch records");
    }

    const responseData = await response.json();
    if(responseData && Array.isArray(responseData)) {
      // Transform each application, keeping the ID for deletion
      const transformedApplications = responseData.map(app => ({
        ...transformData(app),
        _appId: app.id  // Keep ID for deletion
      }));
      setIsAdditionalData(transformedApplications);
    } else if (responseData) {
      // Single application (backwards compatibility)
      const transformedData = {
        ...transformData(responseData),
        _appId: responseData.id
      };
      setIsAdditionalData([transformedData]);
    }

    setIsLoading(false);
    setIsHeader(rest);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {isLoading && <Loading/>}
      {data.map((l) => {
        return (
          <tr key={l.id}
          className={`cursor-pointer ${l.applicationCount > 1 ? 'bg-blue-50' : 'bg-gray-300'} ${isClickable && "hover:bg-white transition-colors"}`}
          onClick={() => isClickable && openModal(l)}>
            {Object.keys(l)
              .filter((key) => key !== "id" && key !== "submissionDate" && key !== "hasDuplicate" && key !== "applicationCount")
              .map((key, index) => (
                <td
                  key={key}
                  className="px-6 py-4 border-b border-gray-200 whitespace-nowrap"
                  style={{ minWidth: '150px' }}
                >
                  <div className="text-sm leading-5 text-gray-900 flex items-center gap-2">
                    {l[key]}
                    {index === 0 && l.applicationCount > 1 && (
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-500 text-white" title={`${l.applicationCount} applications`}>
                        {l.applicationCount} Applications
                      </span>
                    )}
                  </div>
                </td>
              ))}
          </tr>
        );
      })}
      {isClickable && <Modal isOpen={isModalOpen} closeModal={closeModal} header={header} additionalData={additionalData} id={selectedLeadId} deleteUri={deleteUri}/>}
    </>
  );
};

export default Table;
